export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TimeOutSec = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'a952ed54-1c03-4e3a-940f-1db5cdbaedde';
export const MODAL_CLOSE_SEC = 2.5;
